import { configure } from 'mobx';
import { createRoot } from 'react-dom/client';
import { BugsnagEventLogger, EventLogger } from '../models/Logging';
import { polyfillAsync } from '../models/UiUtils';
import { UnsubscribeApp } from './containers/UnsubscribeApp';
import './styles/global-styles.less';

const bugsnagEventLogger = new BugsnagEventLogger(import.meta.env.MODE);
const ErrorBoundary = bugsnagEventLogger.getErrorBoundary();
EventLogger.addLogger(bugsnagEventLogger);

document.addEventListener('DOMContentLoaded', async () => {
	await polyfillAsync();
	configure({ enforceActions: 'never' });

	const root = createRoot(document.getElementById('react-root'));
	root.render(
		<ErrorBoundary>
			<UnsubscribeApp />
		</ErrorBoundary>
	);
});
